<template>
	<footer>
		<div :class="['infos', this.$route.name === 'home' ? '' : 'imagebg']">
			<div class="container">
				<div class="info-box">
					<div class="bluebox">
						<span class="fas fa-question-circle icon"></span>
						<span class="title">Precisa de ajuda?</span>
						<span class="content">curadoria@estacio.br</span>
					</div>
				</div>

				<div class="info-box description container">
					Este software tem por finalidade viabilizar a consulta e o consumo de recursos educacionais, mediante serviço prévio de curadoria de conteúdo. Trata-se de um desenvolvimento integrante do projeto 2020, da Diretoria Acadêmica do grupo YDUQS.
				</div>

				<div class="info-box logo">
					<img src="@/assets/images/ensineme.png" />
				</div>
			</div>
		</div>

		<div class="social">
			<div class="container">
				<div class="copyright">
					YDUQS - Todos os direitos reservados
				</div>

				<div class="social-icons">
					<a target="_new" href="https://www.facebook.com/br.estacio" class="fab fa-facebook-f"></a>
					<a target="_new" href="https://instagram.com/estacio_brasil/" class="fab fa-instagram"></a>
					<a target="_new" href="http://www.youtube.com/estacio" class="fab fa-youtube"></a>
					<a target="_new" href="https://www.linkedin.com/school/estacio/" class="fab fa-linkedin-in"></a>
					<!-- <a target="_new" href="http://www.linkedin.com/edu/school?id=10643" class="fab fa-linkedin-in"></a> -->
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer'
}
</script>

<style lang="scss" scoped>
	footer {
		color: #FFF;
		font-family: 'Roboto Condensed', 'Roboto', sans-serif;

		.infos {
			margin-top: 120px;
			padding: 50px 0;
			background-color: #061529;

			&.imagebg {
				background: #061529 url(../../assets/images/bgblue.png) no-repeat;
			}

			.container {
				display: grid;
				grid-template-columns: 1fr 2fr 1fr;

				@media all and (max-width: 900px) {
					grid-template-columns: 1fr;
				}

				.bluebox {
					padding: 15px;
					margin: 50px;
					background-color: #001736;
					border-radius: 10px;
					text-align: center;

					.icon {
						font-size: 50px;
					}

					.title {
						display: block;
						font-size: 22px;
						font-weight: bold;
					}

					.content {
						display: block;
						font-size: 16px;
						color: #E2E41A;
					}
				}

				.description {
					display: flex;
					align-items: center;
					align-content: center;
					margin: 50px auto;
					font-size: 15px;

					@media all and (max-width: 600px) {
						text-align: justify;
					}
				}

				.logo {
					margin: 50px auto;

					img {
						height: 110px;
					}
				}
			}
		}

		.social {
			background-color: #001736;

			.container {
				display: grid;
				grid-template-columns: 1fr 1fr;
				align-items: center;
				align-content: center;
				border-top: 2px solid #8B94A7;
				padding: 50px 10px;

				@media all and (max-width: 600px) {
					display: block;
				}

				.copyright {
					font-size: 14px;

					@media all and (max-width: 600px) {
						display: block;
						text-align: center;
					}
				}

				.social-icons {
					text-align: right;

					@media all and (max-width: 600px) {
						display: block;
						margin-top: 10px;
						text-align: center;
					}

					a {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 35px;
						height: 35px;
						margin-left: 5px;
						border: 2px solid #FFF;
						border-radius: 50%;
						text-decoration: none;
						color: inherit;

						&:first-child {
							margin-left: 0;
						}
					}
				}
			}
		}
	}
</style>
